<template>
  <div class="card d-print-none mb-2">
    <div class="card-body">
      <router-link :to="taskData.api_url" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" ><i class="feather icon-corner-up-left"></i> {{labels.get('label_back')}}</router-link>
      <template v-if="item.exists">
        <button  type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="save(false)"><i class="feather icon-save"></i> {{labels.get('label_save')}}</button>
      </template>
    </div>
  </div>
  <form id="formSaveItem">
    <input type="hidden" name="save_token" :value="new Date().getTime()">
    <input type="hidden" name="id" :value="item.id">
    <div id="accordion" v-if="item.exists">
      <div class="card">
        <div class="card-header p-1">
          <a class="btn btn-sm" data-toggle="collapse" href="#label_basic_info">Basic Info</a>
        </div>
        <div id="label_basic_info" class="collapse show">
          <div class="card-body row">
            <div class="col-md-3">
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Order Number <span class="text-danger">*</span></label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input id="item_part_number" type="text" class="form-control" v-model="item.data.order_number" name="item[order_number]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Description</label></div>
                <div class="col-7">
                  <div class="input-group"><textarea class="form-control" v-model="item.data.description" name="item[description]"></textarea></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header p-1">
          <a class="btn btn-sm" data-toggle="collapse" href="#label_pn">Part Number </a>
        </div>
        <div id="label_pn" class="collapse show">
          <div class="card-body">
            <div class="row">
              <div class="card-body" style='overflow-x:auto;height:530px;'>
                <table id="table_sub_pns" class="table table-bordered">
                  <thead class="table-active">
                  <tr>
                    <th style="width: 110px;" class="position-relative align-middle d-print-none">{{labels.get('label_action')}}</th>
                    <th style="">Part Number</th>
                    <th style="width: 110px;">Quantity</th>
                    <th style="width: 110px;">Unit</th>
                    <th style="width: 110px;">Unit Cost</th>
                    <th style="width: 110px;">Total Quantity</th>
                    <th style="width: 110px;">Cost</th>
                    <th style="width: 110px;">Total Cost</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr id="tr_pn_add">
                      <td>
                        <button type="button" id="btn_show_sub_pn_search" class="mr-2 mb-2 btn btn-sm bg-gradient-primary"><i class="feather icon-plus-circle"></i> Add </button>
                      </td>
                      <td colspan="7">
                        <div id="container_sub_pn_search" style="display: none">
                          <div class="row ml-2 mr-2 mt-2">
                            <div class="col-md-2">
                              <div class="row">
                                <div class="col-4">
                                  <label class="font-weight-bold float-right">{{labels.get('label_category_name')}}</label>
                                </div>
                                <div class="col-8">
                                  <div class="input-group" >
                                    <select class="form-control" name="options[category_id]">
                                      <option value="">{{labels.get('label_select')}}</option>
                                      <option v-for="(option, i) in taskData.categories" :value="option.id">
                                        {{ option.code }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="row">
                                <div class="col-4">
                                  <label class="font-weight-bold float-right">{{labels.get('label_type_name')}}</label>
                                </div>
                                <div class="col-8">
                                  <div class="input-group" >
                                    <select class="form-control" name="options[type_id]">
                                      <option value="">{{labels.get('label_select')}}</option>
                                      <option v-for="(option, i) in taskData.types" :value="option.id">
                                        {{ option.code }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="row">
                                <div class="col-4">
                                  <label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}}</label>
                                </div>
                                <div class="col-8">
                                  <div class="input-group" >
                                    <select class="form-control" name="options[vendor_id]">
                                      <option value="">{{labels.get('label_select')}}</option>
                                      <option v-for="(option, i) in taskData.vendors" :value="option.id">
                                        {{ option.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="row mb-2">
                                <div class="col-2">
                                  <label class="font-weight-bold float-right">Text</label>
                                </div>
                                <div class="col-10">
                                  <div class="input-group">
                                    <input id="search_text" type="text" class="form-control" name="options[text]">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="searchPN"><i class="feather icon-save"></i> {{labels.get('label_search')}}</button>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="card-body" style='overflow-x:auto;height:330px;'>
                              <table class="table table-bordered">
                                <thead class="table-active">
                                <tr>
                                  <th style="width: 110px;" class="position-relative align-middle d-print-none">{{labels.get('label_action')}}</th>
                                  <template v-for="(column,key) in taskData.columns_searched_pn.all">
                                    <th class="position-relative align-middle" v-if="taskData.columns_searched_pn.hidden.indexOf(key)<0" :key="'th_'+key">
                                      <ColumnSort :columns="taskData.columns_searched_pn" :sortKey="key" :position="'left:5px'"  :onChangeSort="setFilteredSearchedPNs" v-if="taskData.permissions.action_6 && column.sortable"/>
                                      <div class=" text-center " style="width:calc(100% - 33px);margin-left:17px">
                                        {{ column.label }}
                                      </div>
                                      <ColumnFilter :column="column" :position="'right:5px'"  :onChangeFilter="setFilteredSearchedPNs" v-if="taskData.permissions.action_6 && column.filterable"/>
                                    </th>
                                  </template>
                                </tr>
                                </thead>
                                <tbody class="table-striped table-hover">
                                <tr v-for="pn in item.searchedPNsFiltered" >
                                  <td class="col_1 d-print-none">
                                    <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="addPN(pn)"><i class="feather icon-plus-circle"></i> {{labels.get('action_1')}}</button>

                                  </td>
                                  <template v-for="(column,key) in taskData.columns_searched_pn.all">
                                    <td :class="((['id','ordering'].indexOf(key) != -1)?'text-right':'')+(column.class?(' '+column.class):'col_9')" v-if="taskData.columns_searched_pn.hidden.indexOf(key)<0" :key="'td_'+key">
                                      <template v-if="key=='part_number'">{{ pn[key] }}</template>
                                      <template v-else>{{ pn[key] }}</template>

                                    </td>
                                  </template>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script setup>

import globalVariables from "@/assets/globalVariables";
import systemFunctions from "@/assets/systemFunctions";
import toastFunctions from "@/assets/toastFunctions";
import labels from '@/labels'

import ColumnSort from '@/components/ColumnSort.vue';
import ColumnFilter from '@/components/ColumnFilter.vue';
import Pagination from '@/components/Pagination.vue';

import {useRouter} from "vue-router";
import {nextTick,inject, reactive} from "vue";
import axios from "axios";
import InputTemplate from '@/components/InputTemplate.vue';
import {useRoute} from "vue-router/dist/vue-router";


const route =useRoute()
const router =useRouter()
let taskData = inject('taskData')
let item=reactive({
  id:0,
  exists:false,
  searchedPNs: {data:[]},   //from Laravel server with pagination and info
  searchedPNsFiltered: [],    //for display
  data:{
    id:0,
    order_number:'',
    description:'',
    order_items_html:''
  }
})
const searchPN=async()=>{
  item.searchedPNs=[];
  let formData=new FormData(document.getElementById('formSaveItem'))
  formData.set('page','1')
  formData.set('perPage','-1')
  //formData.set('perPage',1)
  await axios.post(taskData.api_url+'/get-part-numbers',formData).then((res)=>{
    if (res.data.error == "") {
      item.searchedPNs=res.data.items
      setFilteredSearchedPNs();
    }
    else{
      toastFunctions.showResponseError(res.data)
    }
  });

}
const setFilteredSearchedPNs=()=>{
  item.searchedPNsFiltered=systemFunctions.getFilteredItems(item.searchedPNs.data,taskData.columns_searched_pn);
}
const getAddPNChildrenPNHtml=(children,pns_info,root_id,input_name)=>{

  let html='';
  for(let i in children){
    html+=('<tr style="display: none;" class="tr_history_id_'+root_id+'">');
    html+=('<td></td>');
    html+=('<td>');
    for(let j=0;j<+children[i].level+1;j++){
      html+=('<button type="button" style="visibility: hidden" class="btn btn-sm bg-gradient-success"><i class="feather icon-plus-circle"></i> </button>');
    }
    html+=('<input type="hidden" name="item[pn_history_ids]['+children[i].id+']" value="'+children[i].id+'">');
    html+=('<input type="hidden" name="'+input_name+'[children]['+children[i].id+'][id]" value="'+children[i].id+'">');
    html+=('<input type="hidden" name="'+input_name+'[children]['+children[i].id+'][level]" value="'+children[i].level+'">');
    html+=('<input type="hidden" name="'+input_name+'[children]['+children[i].id+'][quantity]" value="'+children[i]['quantity']+'">');
    html+=('<input type="hidden" name="'+input_name+'[children]['+children[i].id+'][quantity_unit]" value="'+children[i]['quantity_unit']+'">');
    html+=(pns_info[children[i].id]['part_number']+'</td>');
    html+=('<td class="text-right" data-unit-quantity="'+children[i]['quantity_unit']+'">'+children[i]['quantity']+'</td>');
    html+=('<td>'+(pns_info[children[i].id]['unit']?pns_info[children[i].id]['unit']:'')+ '</td>');
    html+=('<td class="text-right">'+(pns_info[children[i].id]['cost']?pns_info[children[i].id]['cost']:'')+ '</td>');
    html+=('<td class="text-right"></td>');
    html+=('<td class="text-right"></td>');
    html+=('<td class="text-right"></td>');
    html+=('</tr>');
    if(children[i].children){
      html+=getAddPNChildrenPNHtml(children[i].children,pns_info,root_id,input_name+'[children]['+children[i].id+']')
    }
  }

  return html;
}
const addPN=async(pn)=>{
  if($('#tr_pn_'+pn.id).length==0){
    await axios.get(taskData.api_url+'/get-part-number-tree/'+ pn.id).then((res)=>{
      if (res.data.error == "") {
        let tree=res.data.tree;
        let pns_info=res.data.pns_info;
        if(tree.length>0){
          let html = ('<tr id="tr_pn_' + pn.id + '" class="order_item" data-history-id="' + tree[0].id + '">');
          html+=('<td> <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-danger btn_remove_pn" data-pn-id="' + pn.id + '" data-history-id="' + tree[0].id + '"><i class="bi bi-dash-circle"></i> Remove </button></td>');
          html+=('<td>');
          if(tree[0].children){
            html+=('<button type="button" class="btn btn-sm bg-gradient-success but_pn_more_plus" data-history-id="'+tree[0].id+'"><i class="feather icon-plus-circle"></i> </button>');
            html+='<button style="display: none" type="button" class="btn btn-sm bg-gradient-warning but_pn_more_minus" data-history-id="'+tree[0].id+'"><i class="feather icon-minus-circle"></i> </button>';
          }
          else{
            html+=('<button type="button" style="visibility: hidden" class="btn btn-sm bg-gradient-success"><i class="feather icon-plus-circle"></i> </button>');
          }
          html+=('<input type="hidden" name="item[pn_history_ids]['+tree[0].id+']" value="'+tree[0].id+'">');
          html+=(pns_info[tree[0].id]['part_number']+'</td>');

          html+=('<td> <input type="text" name="item[order_items]['+tree[0].id+'][quantity]" value="0" class="form-control text-right order_quantity" /></td>');
          html+=('<td>'+(pns_info[tree[0].id]['unit']?pns_info[tree[0].id]['unit']:'')+ '</td>');
          html+=('<td class="text-right">'+(pns_info[tree[0].id]['cost']?pns_info[tree[0].id]['cost']:'0')+ '</td>');
          html+=('<td class="text-right"></td>');
          html+=('<td class="text-right"></td>');
          html+=('<td class="text-right"></td>');
          html+='</tr>';
          if(tree[0].children){
            html+=getAddPNChildrenPNHtml(tree[0].children,pns_info,tree[0].id,'item[order_items]['+tree[0].id+']')
          }
          $('#tr_pn_add').before(html)
        }
        console.log(res.data)
      }
      else{
        toastFunctions.showResponseError(res.data)
      }
    });
  }
}
const save=async (save_and_new)=>{
  let formData=new FormData(document.getElementById('formSaveItem'))
  $('.order_item').each(function(index, element) {
    let history_id=$(this).attr('data-history-id');
    formData.set('item[order_items]['+history_id+'][total_cost]',(+$(this).children('td').eq(7).text()));
  });

  await axios.post(taskData.api_url+'/save-item',formData).then((res)=>{
    if (res.data.error == "") {
      toastFunctions.showSuccessfullySavedMessage();
      if(save_and_new){
        if(item.id>0){
          router.push(taskData.api_url+"/add")
        }
        else{

        }
      }
      else{
        router.push(taskData.api_url)
      }
      taskData.reloadItems(taskData.pagination)
    }
    else{
      toastFunctions.showResponseError(res.data)
    }
  });

}
// const getEditPNChildrenPNHtml=(children,pns_info,root_id,input_name,level)=>{
//
//   let html='';
//   for(let i in children){
//     html+=('<tr style="display: none;" class="tr_history_id_'+root_id+'">');
//     html+=('<td></td>');
//     html+=('<td>');
//     for(let j=0;j<level+1;j++){
//       html+=('<button type="button" style="visibility: hidden" class="btn btn-sm bg-gradient-success"><i class="feather icon-plus-circle"></i> </button>');
//     }
//     html+=('<input type="hidden" name="item[pn_history_ids]['+children[i].id+']" value="'+children[i].id+'">');
//     html+=('<input type="hidden" name="'+input_name+'[children]['+children[i].id+'][id]" value="'+children[i].id+'">');
//     html+=(pns_info[children[i].id]['part_number']+'</td>');
//     html+=('<td class="text-right" data-unit-quantity="'+children[i]['quantity_unit']+'">'+children[i]['quantity']+'</td>');
//     html+=('<td>'+(pns_info[children[i].id]['unit']?pns_info[children[i].id]['unit']:'')+ '</td>');
//     html+=('<td class="text-right">'+(pns_info[children[i].id]['cost']?pns_info[children[i].id]['cost']:'')+ '</td>');
//     html+=('<td class="text-right"></td>');
//     html+=('<td class="text-right"></td>');
//     html+=('<td class="text-right"></td>');
//     html+=('</tr>');
//     if(children[i].children){
//       html+=getEditPNChildrenPNHtml(children[i].children,pns_info,root_id,input_name+'[children]['+children[i].id+']',level+1)
//     }
//   }
//
//   return html;
// }
const getItem=async ()=>{
  await axios.get(taskData.api_url+'/get-item/'+ item.id).then(async (res) => {
    if (res.data.error == "") {
      let itemData = res.data.item;
      for (let key in itemData) {
        if (!itemData[key]) {
          itemData[key] = '';//setting null value to empty string
        }
      }
      let html = '';
      if (itemData['order_items']) {
        for (let pn_history_id in itemData['order_items']) {
          let pn = itemData['pns_info'][pn_history_id]
          let order_item=itemData['order_items'][pn_history_id]

          html+= ('<tr id="tr_pn_' + pn.part_number_id + '" class="order_item" data-history-id="' + pn.id + '">');
          html+=('<td> <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-danger btn_remove_pn" data-pn-id="' + pn.part_number_id + '" data-history-id="' + pn.id + '"><i class="bi bi-dash-circle"></i> Remove </button></td>');

          html+=('<td>');
          if(order_item.children){
            html+=('<button type="button" class="btn btn-sm bg-gradient-success but_pn_more_plus" data-history-id="'+pn.id+'"><i class="feather icon-plus-circle"></i> </button>');
            html+='<button style="display: none" type="button" class="btn btn-sm bg-gradient-warning but_pn_more_minus" data-history-id="'+pn.id+'"><i class="feather icon-minus-circle"></i> </button>';
          }
          else{
            html+=('<button type="button" style="visibility: hidden" class="btn btn-sm bg-gradient-success"><i class="feather icon-plus-circle"></i> </button>');
          }
          html+=('<input type="hidden" name="item[pn_history_ids]['+pn.id+']" value="'+pn.id+'">');
          html+=(pn['part_number']+'</td>');

          html+=('<td> <input type="text" name="item[order_items]['+pn.id+'][quantity]" value="'+order_item['quantity']+'" class="form-control text-right order_quantity" /></td>');
          html+=('<td>'+(pn['unit']?pn['unit']:'')+ '</td>');
          let unit_cost=(pn['cost']?+pn['cost']:0)
          html+=('<td class="text-right">'+(unit_cost)+ '</td>');
          html+=('<td class="text-right">'+(order_item['quantity'])+ '</td>');
          html+=('<td class="text-right">'+(order_item['quantity']*unit_cost)+ '</td>');
          html+=('<td class="text-right">'+(order_item['total_cost'])+ '</td>');
          html += '</tr>';
          if(order_item.children){
            html+=getAddPNChildrenPNHtml(order_item.children,itemData['pns_info'],pn.id,'item[order_items]['+pn.id+']')
          }
        }
      }
      item.data.order_number = itemData.order_number;
      item.data.description = itemData.description;
      item.data.order_items_html = html;
      item.exists = true;
      await nextTick();
      $('#tr_pn_add').before(item.data.order_items_html)
      $('.order_quantity').trigger('input')
    } else {
      toastFunctions.showResponseError(res.data)
    }
  });
}
$(document).ready(async function()
{
  $(document).off("click", "#btn_show_sub_pn_search");
  $(document).on("click", '#btn_show_sub_pn_search', function () {
    $('#container_sub_pn_search').toggle();
  })
  $(document).off("click", ".btn_remove_pn");
  $(document).on("click",'.btn_remove_pn',function(){
    let history_id=$(this).attr('data-history-id')
    let pn_id=$(this).attr('data-pn-id')
    $('#tr_pn_'+pn_id).remove();
    $('.tr_history_id_'+history_id).remove();
  });
  $(document).off("click", ".but_pn_more_minus");
  $(document).on("click", '.but_pn_more_minus',async function () {
    let history_id=$(this).attr('data-history-id')
    $('.tr_history_id_'+history_id).hide();
    $(this).hide();
    $(this).siblings('.but_pn_more_plus').show();
  })
  $(document).off("click", ".but_pn_more_plus");
  $(document).on("click", '.but_pn_more_plus',async function () {
    let history_id=$(this).attr('data-history-id')
    $('.tr_history_id_'+history_id).show();
    $(this).hide();
    $(this).siblings('.but_pn_more_minus').show();
  })
  $(document).off("input", ".order_quantity");
  $(document).on("input", '.order_quantity',async function () {
    let quantity=(+$(this).val());
    let tr_root=$(this).closest('tr');
    let history_id=tr_root.attr('data-history-id')
    let root_unit_quantity=(+tr_root.children('td').eq(4).text());
    tr_root.children('td').eq(5).text(quantity)
    tr_root.children('td').eq(6).text(quantity*root_unit_quantity);
    let total_cost=quantity*root_unit_quantity;
    $('.tr_history_id_'+history_id).each(function(index, element) {
      let unit_quantity=(+$(this).children('td').eq(2).attr('data-unit-quantity'));
      let unit_cost=(+$(this).children('td').eq(4).text());
      $(this).children('td').eq(5).text(quantity*unit_quantity);
      $(this).children('td').eq(6).text(quantity*unit_quantity*unit_cost);
      total_cost+=(quantity*unit_quantity*unit_cost)
    });
    tr_root.children('td').eq(7).text(total_cost)
  })


})
  item.id=route.params['item_id']?route.params['item_id']:0;
  if(item.id>0){
    if(!(taskData.permissions.action_2)){
      toastFunctions.showAccessDenyMessage();
    }
    else{
      getItem();
    }
  }
  else{
    if(!(taskData.permissions.action_1)){
      toastFunctions.showAccessDenyMessage();
    }
    else{
      item.exists=true;
    }
  }

</script>